var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"primary pa-2"}),_c('v-col',{staticClass:"accent pa-2"}),_c('v-col',{staticClass:"secondary pa-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }